import { helper } from '@ember/component/helper';

import { isSet } from 'rise-ui/utils/nullish.js';
import { set } from 'rise-ui/utils/object.js';

export default helper(function defaultHelper([ ctx, key, val, def ], { truthy }) {
  set(ctx, key, ( truthy === true || truthy === 'true' ? val : isSet(val) ) ? val : def);
  return '';
});
